// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
// import API from '../../../apis/API'
import APIInterceptor from '../../../apis/APIInterceptors'
import propertyListAPIs from '../../../apis/propertyListAPIs'

const fetchListDetails = payload => {
    try {
        return APIInterceptor(propertyListAPIs.getListDetails, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
    // catch (error) {
    //     if (APIInterceptor.isCancel(error)) {
    //     } else {
    //         throw error
    //     }
    // }
}

const saveSavedSearch = payload => {
    try {
        return APIInterceptor(propertyListAPIs.saveSavedSearch, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

// const deleteCompsListProperty = payload => {
//     try {
//         return APIInterceptor(propertyListAPIs.deleteCompsListProperty, payload, 'delete')
//     } catch (ex) {
//         console.log(ex)
//         throw ex
//     }
// }

const modifyUnitMixSourcePreference = payload => {
    try {
        return APIInterceptor(propertyListAPIs.modifyUnitMixSourcePreference, payload)
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

const getMessageStatus = payload => {
    try {
        return APIInterceptor(`${propertyListAPIs.getMessageStatus}${payload}`, '', 'get')
    } catch (ex) {
        console.log(ex)
        throw ex
    }
}

// export { fetchListDetails, saveSavedSearch, deleteCompsListProperty, modifyUnitMixSourcePreference }
export { fetchListDetails, saveSavedSearch, modifyUnitMixSourcePreference, getMessageStatus }
